import React, { useState, useEffect } from 'react'
import styles from './style/search-content-mod.module.less'
import { IconLoading } from '@arco-design/web-react/icon'
import {
  IconCopy,
  IconEditor2,
  IconSearch,
  IconPdf,
  IconContext,
  IconSuccessTip,
  IconWarnTip,
  IconErrorTip,
  IconDetail,
} from '@arco-iconbox/react-aidb-v2'
import {
  Message,
  Input,
  BackTop,
  Tooltip,
  InputTag,
  DatePicker,
} from '@arco-design/web-react'
import {
  geTextSplitting,
  getBookLibrarySearch,
  getBookLibraryBookDetails,
} from './utils/api'
import { includeKeyWord } from './utils/utilsFunction'
import TreeSelectMod from './TreeSelectMod'
import KeywordsBook from './KeywordsBook'
import ModalCustom from '../../components/ModalCustom'
import SearchTextMod from './SearchTextMod'
import SearchHistoryMod from './SearchHistoryMod'
import ContextTree from './ContextTree'
import PDF from './PDF'
import Empty from './Empty'
import Copy from '../Copy'
import useScrollToBottom from './utils/useScrollToBottom'

const BookLibrary = (props) => {
  // 书籍库历史记录数据
  const [bookLibraryHistoryData, setBookLibraryHistoryData] = useState([])
  // 书籍库搜索中
  const [bookLibrarySearching, setBookLibrarySearching] =
    useState<boolean>(false)
  // 搜索记录弹窗
  const [historyVisible, setHistoryVisible] = useState<boolean>(false)
  // 详情显示弹窗
  const [visible, setVisible] = useState<boolean>(false)
  // 上下文弹窗
  const [showContext, setShowContext] = useState<number>(-1)
  // PDF弹窗
  const [showPDF, setShowPDF] = useState<number>(-1)
  // 正文关键字值
  const [mainKeywordsValue, setMainKeywordsValue] = useState<string>('')
  // 正文关键字值拆分
  const [mainKeywordsArr, setMainKeywordsArr] = useState<string[]>([])
  // 书籍分类值
  const [classificationBookValue, setClassificationBookValue] =
    useState<string>('')
  // 书籍分类ID值
  const [classificationBookIdValue, setClassificationBookIDValue] =
    useState<string>('')
  // 书籍关键字值
  const [keywordsBookValue, setKeywordsBookValue] = useState<string>('')
  // 大纲关键字值
  const [keywordsOutlineValue, setKeywordsOutlineValue] = useState<string>('')
  // 正文内容
  const [mainContent, setMainContent] = useState<string>('')
  // 书籍库搜索数据
  const [bookLibrarySearchArray, setBookLibrarySearchArray] = useState<any[]>(
    [],
  )
  // 书籍库数据当前页数
  const [bookLibraryPage, setBookLibraryPage] = useState<number>(0)

  // 初始添加历史记录
  useEffect(() => {
    const bookLibraryHistoryList = JSON.parse(
      window.localStorage.getItem('bookLibraryHistoryList'),
    )
    bookLibraryHistoryList && setBookLibraryHistoryData(bookLibraryHistoryList)
  }, [])

  // 存储历史记录
  useEffect(() => {
    window.localStorage.setItem(
      'bookLibraryHistoryList',
      JSON.stringify(bookLibraryHistoryData),
    )
  }, [bookLibraryHistoryData])

  // 书籍库点击搜索
  const getBookLibrarySearchBack = (
    page: number,
    mainText: string,
    assortId: string,
    assortValue: string,
    bookKeywords: string,
    outlineKeywords: string,
    isAgainSearch?: boolean,
  ) => {
    if (bookLibrarySearching) {
      Message.warning({
        icon: <IconWarnTip useCurrentColor={false} />,
        content: '正在搜索中，请勿重复点击！',
      })
      return
    }

    bookLibraryPage && setBookLibraryPage(0)
    bookLibrarySearchArray.length && setBookLibrarySearchArray([])
    // loading
    setBookLibrarySearching(true)
    if (isAgainSearch === true) {
      setMainKeywordsValue(mainText)
      setClassificationBookValue(assortValue)
      setClassificationBookIDValue(assortId)
      setKeywordsBookValue(bookKeywords)
      setKeywordsOutlineValue(outlineKeywords)
    } else {
      // 添加历史记录
      pushBookLibraryHistory()
    }

    // 发送请求
    getBookLibrarySearchData(
      0,
      mainText,
      assortId,
      bookKeywords,
      outlineKeywords,
    ).then((data: []) => {
      setBookLibrarySearchArray(data)
    })
  }

  // 添加历史记录
  const pushBookLibraryHistory = () => {
    if (
      !mainKeywordsValue &&
      !classificationBookValue &&
      !classificationBookIdValue &&
      !keywordsBookValue &&
      !keywordsOutlineValue
    )
      return
    setBookLibraryHistoryData((historyData) => {
      return [
        {
          mainKeywordsValue,
          classificationBook: {
            classificationBookValue,
            classificationBookIdValue,
          },
          keywordsBookValue,
          keywordsOutlineValue,
        },
        ...historyData,
      ]
    })
  }

  // 删除某条历史记录
  const removerBookLibraryHistory = (index: number) => {
    setBookLibraryHistoryData((historyData) =>
      historyData.filter((_, i) => i !== index),
    )
  }

  // 滚动到底部加载
  const scrollToBottomRef = useScrollToBottom(() => {
    if (bookLibrarySearching || !bookLibrarySearchArray.length) return

    setShowContext(-1)
    setShowPDF(-1)
    // loading
    setBookLibrarySearching(true)

    // 发送请求
    getBookLibrarySearchData(
      bookLibraryPage,
      mainKeywordsValue,
      classificationBookIdValue,
      keywordsBookValue,
      keywordsOutlineValue,
    ).then((data: []) => {
      setBookLibrarySearchArray([...bookLibrarySearchArray, ...data])
    })
  })

  // 发送请求
  const getBookLibrarySearchData = (
    page,
    mainText,
    assortId,
    bookKeywords,
    outlineKeywords,
  ) => {
    return new Promise((resolve, reject) => {
      // 将关键字空格改为‘_’
      geTextSplitting(mainText)
        .then((keyWord) => {
          let keyWords = keyWord.replace(/\s/g, '_')
          setMainKeywordsArr(keyWords.split('_'))
          // 搜索请求
          getBookLibrarySearch({
            page,
            mainText: keyWords,
            assortId,
            bookKeywords,
            outlineKeywords,
          })
            .then((res) => {
              // console.log(res.data)
              if (res.status == 200) {
                resolve(res.data)
                if (res.data.length) {
                  Message.success({
                    icon: <IconSuccessTip useCurrentColor={false} />,
                    content: '搜索数据成功！',
                  })
                  // 页数+1
                  setBookLibraryPage((page) => {
                    return (page += 1)
                  })
                } else {
                  Message.warning({
                    icon: <IconWarnTip useCurrentColor={false} />,
                    content: '此搜索暂无数据！',
                  })
                }
              } else {
                Message.error({
                  icon: <IconErrorTip useCurrentColor={false} />,
                  content: '搜索失败，请重试！',
                })
              }
              setBookLibrarySearching(false)
            })
            .catch((err) => {
              setBookLibrarySearching(false)
              Message.error({
                icon: <IconErrorTip useCurrentColor={false} />,
                content: '搜索失败，请重试！',
              })
              console.log(err)
            })
        })
        .catch((err) => {
          setBookLibrarySearching(false)
          Message.error({
            icon: <IconErrorTip useCurrentColor={false} />,
            content: '搜索失败，请重试！',
          })
          console.log(err)
        })
    })
  }

  return (
    <div className={styles.searchContent}>
      {/*搜索条件*/}
      <div className={styles.searchForm}>
        <div className={styles.title}>
          <h3>搜索条件</h3>
          <p>
            小贴士：缩小搜索范围，将获得更快更精确的内容，如等待时间过长请保存后刷新
          </p>
        </div>
        <div className={styles.box}>
          {/* 输入框 */}
          <div className={styles.formWrap}>
            <div className={styles.formItem}>
              <div className={styles.label}>正文关键字：</div>
              <div className={styles.con}>
                <Input
                  className={'red-input'}
                  value={mainKeywordsValue}
                  onChange={setMainKeywordsValue}
                  disabled={bookLibrarySearching}
                  allowClear
                  height={40}
                  placeholder=""
                />
              </div>
            </div>
            <div className={styles.formItem}>
              <div className={styles.label}>书籍分类：</div>
              <div className={styles.con}>
                <TreeSelectMod
                  category="BOOK_CLASSIFICATION"
                  disabled={bookLibrarySearching}
                  value={classificationBookValue}
                  setValue={setClassificationBookValue}
                  idValue={classificationBookIdValue}
                  setIdValue={setClassificationBookIDValue}
                />
              </div>
            </div>
            <div className={styles.formItem}>
              <div className={styles.label}>书籍关键字：</div>
              <div className={styles.con}>
                <KeywordsBook
                  category="BOOK_KEYWORDS"
                  disabled={bookLibrarySearching}
                  value={keywordsBookValue}
                  setValue={setKeywordsBookValue}
                />
              </div>
            </div>
            <div className={styles.formItem}>
              <div className={styles.label}>大纲关键字：</div>
              <div className={styles.con}>
                <KeywordsBook
                  category="OUTLINE_KEYWORDS"
                  disabled={bookLibrarySearching}
                  value={keywordsOutlineValue}
                  setValue={setKeywordsOutlineValue}
                />
              </div>
            </div>
          </div>
          {/* 按钮 */}
          <div className={styles.formBot}>
            <div className={styles.left}>
              {/* 搜索按钮 */}
              {!bookLibrarySearching ? (
                <div
                  className={styles.btn}
                  onClick={() =>
                    getBookLibrarySearchBack(
                      bookLibraryPage,
                      mainKeywordsValue,
                      classificationBookIdValue,
                      classificationBookValue,
                      keywordsBookValue,
                      keywordsOutlineValue,
                    )
                  }>
                  <div className={styles.icon}>
                    <IconSearch useCurrentColor={true} />
                  </div>
                  <div className={styles.txt}>搜索</div>
                </div>
              ) : (
                <div className={styles.btn} style={{ userSelect: 'none' }}>
                  <div className={styles.icon}>
                    <IconLoading style={{ fill: 'none' }} />
                  </div>
                  <div className={styles.txt}>搜索中...</div>
                </div>
              )}
              <div
                className={styles.txtBtn}
                onClick={() => {
                  setMainKeywordsValue('')
                  setClassificationBookValue('')
                  setClassificationBookIDValue('')
                  setKeywordsBookValue('')
                  setKeywordsOutlineValue('')
                  setBookLibraryPage(0)
                }}>
                重置
              </div>
            </div>
            <div className={styles.right}>
              <div
                className={styles.txtBtn}
                onClick={() => {
                  setHistoryVisible(true)
                }}>
                搜索记录
              </div>
            </div>
          </div>
        </div>
      </div>
      {/*搜索结果*/}
      <div className={styles.searchResult}>
        <div className={styles.title}>搜索结果：</div>
        <div
          id="custom_backTop"
          className={styles.resultList}
          ref={scrollToBottomRef}>
          {bookLibrarySearchArray.length ? (
            bookLibrarySearchArray.map((item, index) => {
              return (
                <div className={styles.item} key={index}>
                  <div className={styles.top}>
                    <div className={styles.index}>{index + 1}.</div>
                    <div className={styles.info}>
                      {/* 分类 */}
                      <div className={styles.box}>
                        <div className={styles.type}>分类</div>
                        <Tooltip content={item.cat.properties.name}>
                          <div
                            className={styles.con}
                            dangerouslySetInnerHTML={{
                              __html: classificationBookValue
                                ? includeKeyWord(item.cat.properties.name, [
                                    classificationBookValue,
                                  ])
                                : item.cat.properties.name,
                            }}></div>
                        </Tooltip>
                      </div>
                      {/* 书籍 */}
                      <div className={styles.box}>
                        <div className={styles.type}>书籍</div>
                        <Tooltip content={item.book.properties.name}>
                          <div
                            className={styles.con}
                            dangerouslySetInnerHTML={{
                              __html: keywordsBookValue
                                ? includeKeyWord(item.book.properties.name, [
                                    keywordsBookValue,
                                  ])
                                : item.book.properties.name,
                            }}></div>
                        </Tooltip>
                      </div>
                      {/* 大纲 */}
                      <div className={styles.box}>
                        <div className={styles.type}>大纲</div>
                        <Tooltip content={item.nav.properties.name}>
                          <div
                            className={styles.con}
                            dangerouslySetInnerHTML={{
                              __html: keywordsOutlineValue
                                ? includeKeyWord(item.nav.properties.name, [
                                    keywordsOutlineValue,
                                  ])
                                : item.nav.properties.name,
                            }}></div>
                        </Tooltip>
                      </div>
                    </div>
                  </div>
                  <div className={styles.bot}>
                    <div className={styles.left}></div>
                    <div className={styles.right}>
                      {/* 正文内容 */}
                      <div
                        className={styles.text}
                        onClick={() => {
                          setMainContent(item.para.properties.paraRaw)
                          setVisible(true)
                        }}
                        dangerouslySetInnerHTML={{
                          __html: mainKeywordsValue
                            ? includeKeyWord(
                                item.para.properties.paraRaw,
                                mainKeywordsArr,
                              )
                            : item.para.properties.paraRaw,
                        }}></div>
                      {/* 按钮 */}
                      <div className={styles.btnGroup}>
                        {/* 左边按钮 */}
                        <div className={styles.l}>
                          {/* 编辑 */}
                          <div
                            className={styles.btn}
                            onClick={() => {
                              setMainContent(item.para.properties.paraRaw)
                              setVisible(true)
                            }}>
                            <div className={styles.icon}>
                              <IconEditor2 useCurrentColor={true} />
                            </div>
                            <div className={styles.txt}>编辑</div>
                          </div>
                          {/* 复制 */}
                          <Copy
                            className={styles.btn}
                            text={item.para.properties.paraRaw}
                            onCopy={() => {
                              Message.success({
                                icon: (
                                  <IconSuccessTip useCurrentColor={false} />
                                ),
                                content: '复制成功！',
                              })
                            }}
                            content={
                              <>
                                <div className={styles.icon}>
                                  <IconCopy useCurrentColor={true} />
                                </div>
                                <div className={styles.txt}>复制</div>
                              </>
                            }
                          />
                          {/* 上下文 */}
                          <div
                            className={`${styles.btn} ${
                              showContext === index ? styles.active : ''
                            }`}
                            onClick={() => {
                              setShowPDF(-1)
                              showContext === index
                                ? setShowContext(-1)
                                : setShowContext(index)
                            }}>
                            <div className={styles.icon}>
                              <IconContext useCurrentColor={true} />
                            </div>
                            <div className={styles.txt}>上下文</div>
                          </div>
                          {/* PDF */}
                          <div
                            className={`${styles.btn} ${
                              showPDF === index ? styles.active : ''
                            }`}
                            onClick={() => {
                              setShowContext(-1)
                              showPDF === index
                                ? setShowPDF(-1)
                                : setShowPDF(index)
                            }}>
                            <div className={styles.icon}>
                              <IconPdf useCurrentColor={true} />
                            </div>
                            <div className={styles.txt}>PDF</div>
                          </div>
                        </div>
                        {/* 右边按钮 */}
                        <div className={styles.r}>
                          {/* 详情 */}
                          <div
                            className={`${styles.btn} ${styles.noBorder}`}
                            onClick={() =>
                              window.open(
                                getBookLibraryBookDetails(
                                  item.book.properties.uuid,
                                ),
                                '_blank',
                              )
                            }>
                            <div className={styles.icon}>
                              <IconDetail />
                            </div>
                            <div className={styles.txt}>详情</div>
                          </div>
                        </div>
                      </div>
                      {/* 上下文弹出框 */}
                      {showContext === index && (
                        <ContextTree uuid={item.book.properties.uuid} />
                      )}
                      {/* PDF弹出框 */}
                      {showPDF === index && (
                        <PDF
                          uuid={item.book.properties.uuid}
                          page={item.nav.properties.page}
                          title={
                            keywordsBookValue ? keywordsBookValue : '文件预览'
                          }
                        />
                      )}
                    </div>
                  </div>
                </div>
              )
            })
          ) : (
            <Empty title="暂无数据！" state={bookLibrarySearching} />
          )}

          {/* 加载更多 */}
          {bookLibrarySearching && bookLibrarySearchArray.length ? (
            <div className={styles.scrollToBottom}>正在加载更多......</div>
          ) : (
            ''
          )}
        </div>
      </div>

      {/* 返回顶部 */}
      <BackTop
        visibleHeight={30}
        style={{ position: 'absolute', right: '5px' }}
        target={() => document.getElementById('custom_backTop')}
      />

      {/*正文内容*/}
      <ModalCustom
        width={'650px'}
        className={styles.textPop}
        title={null}
        visible={visible}
        close={() => setVisible(false)}
        content={
          <SearchTextMod
            setVisible={setVisible}
            content={mainContent}
            keyWord={mainKeywordsValue}
          />
        }
      />

      {/*搜索记录*/}
      <ModalCustom
        width={'650px'}
        className={styles.textPop}
        title={null}
        visible={historyVisible}
        close={() => setHistoryVisible(false)}
        content={
          <SearchHistoryMod
            category="BOOK_LIBRARY"
            page={bookLibraryPage}
            setPage={setBookLibraryPage}
            setHistoryVisible={setHistoryVisible}
            historyData={bookLibraryHistoryData}
            removerHistory={removerBookLibraryHistory}
            getSearchBack={getBookLibrarySearchBack}
            setHistoryData={setBookLibraryHistoryData}
          />
        }
      />
    </div>
  )
}

export default BookLibrary
